// De instellingen van de widget, op één plek.
//
// Ze werden op 21 plekken rechtstreeks uit process.env gelezen. Dat werkte bij react-scripts, maar
// Vite kent process.env niet: daar heet het import.meta.env. In plaats van 28 losse aanroepen om te
// zetten staat het lezen nu hier, één keer, met een naam en een uitleg per instelling. (WI11.)
//
// Wat dat verder oplevert:
//
//   - Een ontbrekende instelling valt op bij het opstarten in plaats van halverwege een boeking.
//   - De namen staan op één plek, dus een typefout in een naam is te zien.
//   - Er staat bij wat er gebeurt als een instelling leeg is.
//
// Wat er NIET in staat: de waarden zelf. Die komen uit .env.local (lokaal) of uit de bestanden die
// het uitrolgereedschap klaarzet. Er hoort nooit een sleutel in dit bestand.

const bron = import.meta.env;

/** Een tekst uit de instellingen, met een terugval. */
function tekst(naam, terugval = '') {
    const waarde = bron[naam];

    return waarde === undefined || waarde === null || waarde === '' ? terugval : String(waarde);
}

/** Een getal uit de instellingen. Staat er iets onleesbaars, dan de terugval. */
function getal(naam, terugval) {
    const waarde = parseFloat(bron[naam]);

    return Number.isFinite(waarde) ? waarde : terugval;
}

// Let op: de adressen worden hier bewust NIET opgeschoond -- geen schuine streep erbij, geen spatie
// eraf. Dat zou netter zijn, maar deze taak gaat over het startpunt en niet over gedrag, en een
// adres dat een streep meer of minder heeft kan een plaatje anders laten laden. Dat opschonen hoort
// in een eigen taak, met een tegenproef erbij. (WI11.)

/** Het adres van het koppelvlak. Zonder dit werkt er niets. */
export const apiAdres = tekst('REACT_APP_API_URL');

/** Waar de afbeeldingen vandaan komen. */
export const afbeeldingAdres = tekst('REACT_APP_API_LOCAL_IMG_URL');

/** De geheime sleutel die bij een verzoek meegaat. */
export const geheimeSleutel = tekst('REACT_APP_SECRET_KEY');

/** Welke omgeving dit is: development, staging of production. */
export const omgeving = tekst('REACT_APP_ENVIRONMENT', 'production');

/** De versie, zodat een foutmelding te herleiden is naar een uitrol. */
export const versie = tekst('REACT_APP_VERSION');

/** De foutopvang. Leeg betekent: Sentry staat uit. */
export const sentryAdres = tekst('REACT_APP_SENTRY_DSN');

/** Welk deel van de bezoeken wordt gemeten. */
export const sentryMeetdeel = getal('REACT_APP_SENTRY_TRACES_SAMPLE_RATE', 0.2);

/** Welk deel van de bezoeken wordt opgenomen. */
export const sentryOpnamedeel = getal('REACT_APP_SENTRY_REPLAY_SAMPLE_RATE', 0.1);

/** Welk deel van de bezoeken met een fout wordt opgenomen. */
export const sentryFoutopnamedeel = getal('REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE', 1.0);

/** Draait dit op een werkplek? */
export const isOntwikkeling = Boolean(bron.DEV);

/**
 * Kijkt bij het opstarten of alles er is wat er moet zijn.
 *
 * Gooit niet: een widget die niet opstart is erger dan een widget die het zonder Sentry doet. Het
 * enige dat echt moet, is het adres van het koppelvlak, en daar valt niets aan te doen behalve het
 * melden.
 */
export function instellingenNakijken() {
    const mist = [];

    if (!apiAdres) mist.push('REACT_APP_API_URL');

    if (mist.length && isOntwikkeling) {
        // Alleen op een werkplek. Bij een gast hoort er niets in de console te staan.
        // eslint-disable-next-line no-console
        console.error('Deze instellingen ontbreken: ' + mist.join(', '));
    }

    return mist;
}
